import React, { useState, useCallback } from 'react';
import TabSelection from './components/TabSelection';
import SideBar from './components/sidebar';
import Cohorts from './Cohorts';

const tabs = [
  {
    label: 'Cohorts',
    show: { search: true, filters: { date: true, email: false } },
  },
];

const Tabs = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState({});
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [openSideActionBoard, setOpenSideActionBoard] = useState(false);
  const [refetchCohorts, setRefetchCohorts] = useState(null);

  const handleCohortSuccess = useCallback(() => {
    if (refetchCohorts && typeof refetchCohorts === 'function') {
      refetchCohorts();
    }
  }, [refetchCohorts]);

  return (
    <div>
      {openSideActionBoard && (
        <SideBar
          openSideActionBoard={openSideActionBoard}
          setOpenSideActionBoard={setOpenSideActionBoard}
          onSuccess={handleCohortSuccess}
        />
      )}
      <TabSelection
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filter={filter}
        setFilter={setFilter}
        setOpenSideActionBoard={setOpenSideActionBoard}
      />
      <div style={{ gap: '8px', overflow: 'auto' }} className="flex flex-col">
        {currentTab?.label === 'Cohorts' && (
          <Cohorts
            searchQuery={searchQuery}
            filter={filter}
            setOpenSideActionBoard={setOpenSideActionBoard}
            setRefetchCohorts={setRefetchCohorts}
          />
        )}
      </div>
    </div>
  );
};

export default Tabs;
